import React, { useMemo } from 'react';
import { Document, Page, Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';
import Lato from './../../../../fonts/Lato/Lato-Regular.ttf';

// Create styles
const BORDER_COLOR = '#ccced3';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
    body: {
        padding: 15,
        paddingTop: 17,
        paddingBottom: 41,
    },
    imageWrapper: {
        alignItems: 'center',
        flexDirection: 'row',
        display: 'flex',
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center',
    },
    image: {
        height: 'auto',
        margin: '0 auto',
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
    },
    tableColCommonHeader: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: '#000',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: '#6d7279',
        opacity: 0.7,
    },
    tableCellHeader: {
        fontFamily: 'Lato',
        fontSize: 7,
        fontWeight: 600,
        fontStyle: 'normal',
        textAlign: 'center',
        padding: 3,
        color: 'white',

    },
    tableColCommon: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCell: {
        fontFamily: 'Lato',
        fontSize: 8,
        fontWeight: 600,
        fontStyle: 'normal',
        textAlign: 'center',
        padding: 3,
        color: '#121416',
    },
    titleWrapper: {
        fontFamily: 'Lato',
        fontSize: 7,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        color: '#6d7279',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: 20,
    },
    pageTitle: {

    },
    pageNum: {
        marginLeft: 'auto',
        marginTop: 'auto',
    }
});


Font.register({
    family: "Lato",
    src: Lato
});

const HeaderRow = ({ data, widthMap }) => <View style={styles.tableRow} fixed>
    {data.map((cell, i) => {
        return <View style={{ ...styles.tableColCommonHeader, width: widthMap[i] + '%' }}>
            <Text style={styles.tableCellHeader}>{cell}</Text>
        </View>;
    })}
</View>;

const Row = ({ data, widthMap }) => <View style={styles.tableRow}>
    {data.map((cell, i) => {
        return <View style={{ ...styles.tableColCommon, width: widthMap[i] + '%' }}>
            <Text style={styles.tableCell}>{cell}</Text>
        </View>;
    })}
</View>;

// Create Document Component
const PdfDocument = (props) => {
const {data=[], title, subTitle, columns=[], widthMap=[]} = props;
    return (
        <Document>
            <Page style={styles.body} wrap>
                <View style={styles.imageWrapper} fixed render={({ pageNumber }) => (
                    <Image src="/images/henig-logo-white-small.jpg" style={{ ...styles.image, width: pageNumber === 1 ? 140 : 50, marginBottom: pageNumber === 1 ? -20 : -20 }} />
                )} />
                <View style={styles.titleWrapper} fixed>
                    <View style={styles.pageTitle}>
                        <Text style={{ fontWeight: 900, color: 'black' }}>{title}</Text>
                        <Text>{subTitle}</Text>
                    </View>
                    <View style={styles.pageNum}>
                        <Text
                            render={({ pageNumber, totalPages }) =>
                                `Page ${pageNumber} / ${totalPages}`
                            }
                            fixed
                        />
                    </View>
                </View>
                <View style={styles.table}>
                    <HeaderRow data={columns} widthMap={widthMap} />
                    {data.map(dataRow => <Row data={dataRow} widthMap={widthMap} />)}
                </View>
            </Page>
        </Document>
    );
}

export default PdfDocument;